import { Component, Element, Prop, Watch, h } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY, delayPageChange } from '../../global/utility/tracking-helpers';
import { getFromDay, getLocaleTimeWithSuffix, getToDay } from '../../helper';
import { UiCmsContactChannelsPhoneBody } from '../ui-cms-contact-channels/ui-cms-contact-channels-phone/ui-cms-contact-channels-phone';

@Component({
  tag: 'ui-cms-contact-channels-phone-sticky-toolbar',
  styleUrl: 'ui-cms-contact-channels-phone-sticky-toolbar.scss',
})
export class UiCmsContactChannelsPhoneStickyToolbar {
  @Element() el: HTMLUiCmsContactChannelsPhoneStickyToolbarElement;

  @Prop({ mutable: true }) body: UiCmsContactChannelsPhoneBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Prop({ mutable: true }) i18n: { [key: string]: string } = {
    fromMonday: 'Montag',
    fromTuesday: 'Dienstag',
    fromWednesday: 'Mittwoch',
    fromThursday: 'Donnerstag',
    fromFriday: 'Freitag',
    fromSaturday: 'Samstag',
    fromSunday: 'Sonntag',
    fromTime: 'von',
    toMonday: 'Montag',
    toTuesday: 'Dienstag',
    toWednesday: 'Mittwoch',
    toThursday: 'Donnerstag',
    toFriday: 'Freitag',
    toSaturday: 'Samstag',
    toSunday: 'Sonntag',
    toTime: 'bis',
    toWeekday: 'bis',
  };

  private buttonTitle: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
    this.buttonTitle = this.body.buttonTitle ?? 'Anrufen';
  }

  @Watch('utilityI18n')
  i18nChangeHandler(newValue: string) {
    this.i18n = newValue ? JSON.parse(newValue) : this.i18n;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    this.i18nChangeHandler(this.utilityI18n);
  }

  removeSpaces(): string {
    return this.body.number.replace(/ /g, '');
  }

  onLinkClick(e: Event, link: HTMLAnchorElement) {
    e.stopPropagation();
    delayPageChange(DEFAULT_TRACKING_DELAY, e, link);

    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Phone via Sticky Toolbar',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.removeSpaces(),
        target: this.removeSpaces(),
      },
      category: {
        area: 'Sticky Toolbar',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  onCallClick(e: Event, link: HTMLAnchorElement) {
    e.stopPropagation();
    delayPageChange(DEFAULT_TRACKING_DELAY, e, link);

    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Phone via Sticky Toolbar',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Button',
        elementLabel: this.buttonTitle,
        target: `${this.removeSpaces()}`,
      },
      category: {
        area: 'Sticky Toolbar',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  render() {
    const link = `tel:${this.body.number}`;
    return (
      <div class="channel-contactbox">
        {this.body.headline && <h3 class="sd-headline sd-headline--size-lg">{this.body.headline}</h3>}
        {this.body.text && <p class="sd-paragraph" innerHTML={this.body.text}></p>}
        <sd-link
          href={link}
          class="copy"
          onClick={(event: Event) => this.onLinkClick(event, event.currentTarget as HTMLAnchorElement)}
        >
          <meta itemProp="telephone" content={this.body.number} />
          <strong>{this.body.number} </strong>
        </sd-link>
        <p class="sd-paragraph">
          <time itemProp="openingHours">
            {`${this.i18n[getFromDay(this.body.fromDay)]} `}
            {this.i18n?.toWeekday}
            {` ${this.i18n[getToDay(this.body.toDay)]} `}
            {this.i18n?.fromTime}
            {` ${getLocaleTimeWithSuffix(this.body.fromTime)} `}
            {this.i18n?.toTime}
            {` ${getLocaleTimeWithSuffix(this.body.toTime)} `}
          </time>
        </p>
        <sd-button
          href={link}
          variant="cta"
          onClick={(event: Event) => this.onLinkClick(event, event.currentTarget as HTMLAnchorElement)}
        >
          {this.buttonTitle}
        </sd-button>
      </div>
    );
  }
}
